const RX_COLLECTION_KEYS = [
	'patients_win_rx_data',
	'patients_win_rx_data_delivered',
	'patients_win_rx_data_today_missed',
	'patients_win_rx_data_final_missed',
	'active_rx_data',
	'rx_data',
];

export const getPatientPrescriptionRows = (patientData, rxData) => {
	if (Array.isArray(rxData)) return rxData;

	for (const key of RX_COLLECTION_KEYS) {
		if (Array.isArray(patientData?.[key]) && patientData[key].length > 0) {
			return patientData[key];
		}
	}

	return [];
};

export const hasSavedPharmacistSignature = (rx) =>
	Boolean(rx?.f_sign_pharmasist_id && rx?.f_pharmasist_sign_name);

export const shouldHideDriverPharmacistSignature = ({ patientData, rxData } = {}) => {
	const rxRows = getPatientPrescriptionRows(patientData, rxData);
	if (!Array.isArray(rxRows) || rxRows.length === 0) return false;

	return rxRows.every(hasSavedPharmacistSignature);
};

